module.exports = __webpack_public_path__ + "media/images/pic/anime/lock-449344735dce84a541b9a5e1d4fff5b8.svg";